import React from 'react'
import PropTypes from 'prop-types'
import styles from './style.module.scss'
import Image from 'next/future/image'
import { getImgURL } from '@shared-submodule/utils'
import CustomLink from '@shared/components/customLink'

const EditorsPick = ({ news }) => {
  return (
    <>
      <CustomLink href={`/${news?.oSeo?.sSlug}`}>
        <a>
          <div className={styles.editors} >
            <Image src={getImgURL(news?.oImg?.sUrl)} alt='Editors title' width={420} height={250} style={{ borderRadius: '16px' }} />
            <div className='d-flex flex-row gap-2'>
              <span className={styles.line}></span>
              <h6 className={styles.title}>{news?.sTitle}</h6>
            </div>
            <p className={styles.description}>{news?.sDescription?.length > 40 ? `${news.sDescription.slice(0, 90)}...` : news.sDescription}</p>
          </div>
        </a>
      </CustomLink>
    </>
  )
}

EditorsPick.propTypes = {
  news: PropTypes.array
}

export default EditorsPick
